import Main from './Main'
import Lista from './components/Reintegrador'
import Novo from './components/NovoReintegrador'

export default [
  {
    path: 'pc-reintegrador',
    name: 'policiacivil.processo.reintegrador',
    component: Main,
    redirect: { name: 'policiacivil.processo.reintegrador.list' },
    children: [
      {
        path: '/',
        name: 'policiacivil.processo.reintegrador.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'policiacivil.processo.reintegrador.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'policiacivil.processo.reintegrador.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/processo/reintegrador/reintegrador/routes.js